import queryKeys from '@/constants/queryKeys';
import { rejectCreatorApplication } from '@/services/api/requests/creator-applications';
import { TCustomAxiosError } from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';

const useRejectCreatorApplication = (id: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: async (decisionNotes: string) => {
      const response = await rejectCreatorApplication(id, decisionNotes);
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.creatorApplications.all] });
      await queryClient.invalidateQueries({ queryKey: [queryKeys.creatorApplications.byId, id] });
      toast({ status: 'success', title: 'Success', description: 'Application rejected.' });
      onSuccess?.();
    },
    onError: async (error: TCustomAxiosError) => {
      // Another admin may have already decided this one — refresh so the view reflects
      // the current status (and hides the now-invalid action buttons).
      await queryClient.invalidateQueries({ queryKey: [queryKeys.creatorApplications.byId, id] });
      await queryClient.invalidateQueries({ queryKey: [queryKeys.creatorApplications.all] });
      toast({
        status: 'error',
        title: 'Error rejecting application',
        description: error.errors?.[0]?.message,
      });
    },
  });

  return { isPending, isSuccess, mutate };
};

export default useRejectCreatorApplication;
